import * as yup from 'yup';

const addOrEditEquipmentSchema = {
  commentForReviewer: yup.string().nullable(),
  equipmentNumber: yup.string().nullable(),
  name: yup.string().required('name is required'),
  status: yup.string().required('status is required'),
  equipmentCategoryTypeSubType: yup.string().required('Category is required'),
  description: yup.string().nullable(),
  manufacturer: yup.string().nullable(),
  model: yup.string().nullable(),
  physicalLocation: yup.string().nullable(),
  serial: yup.string().nullable(),
  jurisdiction: yup.string().nullable(),
  jurisdictionNumber: yup.string().nullable(),
  fieldTagNumber: yup.string().nullable(),
  manufacturedYear: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
    .max(9999, 'invalid year'),

  isNew: yup.boolean().nullable(),
  verificationStatus: yup.string().nullable(),
  pvIds: yup.array().of(
    yup.object().shape({
      pvId: yup.string(),
      psvId: yup.string(),
      verificationStatus: yup.string().nullable()
    })
  ),
  equipmentCategory: yup.string().nullable(),
  equipmentType: yup.string().nullable(),

  equipmentId: yup.string().nullable(),
  link: yup.string().nullable(),
  equipmentEditingStatus: yup.string().nullable(),
  moreFieldsReconcileValues: yup.mixed(),

  'name-reconcile': yup.string().nullable(),
  'status-reconcile': yup.string().nullable(),
  'equipmentCategoryTypeSubType-reconcile': yup.string().nullable(),
  'description-reconcile': yup.string().nullable(),
  'manufacturer-reconcile': yup.string().nullable(),
  'model-reconcile': yup.string().nullable(),
  'physicalLocation-reconcile': yup.string().nullable(),
  'serial-reconcile': yup.string().nullable(),
  'jurisdiction-reconcile': yup.string().nullable(),
  'jurisdictionNumber-reconcile': yup.string().nullable(),
  'fieldTagNumber-reconcile': yup.string().nullable(),
  'manufacturedYear-reconcile': yup.string().nullable(),
  'verificationStatus-reconcile': yup.string().nullable(),

  psv: yup.array().of(
    yup.object().shape({
      commentForReviewer: yup.string().nullable(),
      equipmentNumber: yup.string().nullable(),
      name: yup.string().required('name is required'),
      status: yup.string().required('status is required'),
      equipmentCategoryTypeSubType: yup.string().required('Category is required'),
      description: yup.string().nullable(),
      manufacturer: yup.string().nullable(),
      model: yup.string().nullable(),
      physicalLocation: yup.string().nullable(),
      serial: yup.string().nullable(),
      jurisdiction: yup.string().nullable(),
      jurisdictionNumber: yup.string().nullable(),
      fieldTagNumber: yup.string().nullable(),
      manufacturedYear: yup.string().nullable(),
      isNew: yup.boolean().nullable(),
      verificationStatus: yup.string().nullable(),
      pvIds: yup.array().of(
        yup.object().shape({
          pvId: yup.string(),
          psvId: yup.string(),
          verificationStatus: yup.string().nullable()
        })
      ),
      equipmentCategory: yup.string().nullable(),
      equipmentType: yup.string().nullable(),

      equipmentId: yup.string().nullable(),
      link: yup.string().nullable(),
      equipmentEditingStatus: yup.string().nullable(),

      'name-reconcile': yup.string().nullable(),
      'status-reconcile': yup.string().nullable(),
      'equipmentCategoryTypeSubType-reconcile': yup.string().nullable(),
      'description-reconcile': yup.string().nullable(),
      'manufacturer-reconcile': yup.string().nullable(),
      'model-reconcile': yup.string().nullable(),
      'physicalLocation-reconcile': yup.string().nullable(),
      'serial-reconcile': yup.string().nullable(),
      'jurisdiction-reconcile': yup.string().nullable(),
      'jurisdictionNumber-reconcile': yup.string().nullable(),
      'fieldTagNumber-reconcile': yup.string().nullable(),
      'manufacturedYear-reconcile': yup.string().nullable(),
      'verificationStatus-reconcile': yup.string().nullable()
    })
  ),
  vessel: yup.array().of(
    yup.object().shape({
      id: yup.string().nullable(),
      link: yup.string().nullable(),
      equipmentEditingStatus: yup.string().nullable(),
      title: yup.string().nullable(),
      name: yup.string().nullable(),
      serial: yup.string().nullable()
    })
  )
};

const addOrEditEquipmentSchemaForNewEquipment = {
  commentForReviewer: yup.string().nullable(),
  name: yup.string().required('name is required'),
  status: yup.string().required('status is required'),
  equipmentCategoryTypeSubType: yup.string().required('Category is required'),
  description: yup.string().nullable(),
  manufacturer: yup.string().nullable(),
  model: yup.string().nullable(),
  physicalLocation: yup.string().nullable(),
  serial: yup.string().nullable(),
  jurisdiction: yup.string().nullable(),
  jurisdictionNumber: yup.string().nullable(),
  fieldTagNumber: yup.string().nullable(),
  manufacturedYear: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
    .max(9999, 'invalid year')
};

const defaultValues = {
  commentForReviewer: '',
  equipmentNumber: '',
  name: '',
  status: '',
  equipmentCategoryTypeSubType: '',
  description: '',
  manufacturer: '',
  model: '',
  physicalLocation: '',
  serial: '',
  jurisdiction: '',
  jurisdictionNumber: '',
  fieldTagNumber: '',
  manufacturedYear: '',
  isNew: false,
  verificationStatus: '',
  equipmentCategory: '',
  equipmentType: '',
  equipmentId: '',
  link: '',
  equipmentEditingStatus: '',
  moreFieldsReconcileValues: {},

  'name-reconcile': '',
  'status-reconcile': '',
  'equipmentCategoryTypeSubType-reconcile': '',
  'description-reconcile': '',
  'manufacturer-reconcile': '',
  'model-reconcile': '',
  'physicalLocation-reconcile': '',
  'serial-reconcile': '',
  'jurisdiction-reconcile': '',
  'jurisdictionNumber-reconcile': '',
  'fieldTagNumber-reconcile': '',
  'manufacturedYear-reconcile': '',
  'verificationStatus-reconcile': ''
};

const defaultValuesForNewEquipment = {
  commentForReviewer: '',
  name: '',
  status: '',
  equipmentCategoryTypeSubType: '',
  description: '',
  manufacturer: '',
  model: '',
  physicalLocation: '',
  serial: '',
  jurisdiction: '',
  jurisdictionNumber: '',
  fieldTagNumber: '',
  manufacturedYear: ''
};

const equipmentMoreFieldsSchema = ({ moreInfoFormFields }) => {
  const schemaArray = [];

  for (let x of moreInfoFormFields) {
    const removeSpecialCharactersForName = x.removeSpecialCharactersForName;
    if (x?.type === 'YN') {
      let z = {
        [`${removeSpecialCharactersForName}`]: yup.object().shape({
          [x?.formFieldId]: yup.bool().default(false)
        })
      };

      schemaArray.push(z);
    }

    if (x?.type === 'Date_Nullable' || x?.type === 'Date') {
      let z = {
        [`${removeSpecialCharactersForName}`]: yup.object().shape({
          [x?.formFieldId]: yup.date()?.nullable()
        })
      };
      schemaArray.push(z);
    }

    if (x?.type === 'Dropdown' || x?.type === 'Dropdown_PL') {
      let z = {
        [`${removeSpecialCharactersForName}`]: yup.object().shape({
          [x?.formFieldId]: yup.string()?.nullable()
        })
      };
      schemaArray.push(z);
    }

    if (x?.type === 'LongText' || x?.type === 'Text' || x?.type === 'PhoneNumber') {
      let z = {
        [`${removeSpecialCharactersForName}`]: yup.object().shape({
          [x?.formFieldId]: yup.string()?.nullable()
        })
      };
      schemaArray.push(z);
    }

    if (x?.type === 'Numeric') {
      let z = {
        [`${removeSpecialCharactersForName}`]: yup.object().shape({
          [x?.formFieldId]: yup.lazy((value) =>
            value === ''
              ? yup
                  .string()
                  .test('isRequired', 'Required', (value) => (x.isRequired ? Boolean(value) : true))
              : yup
                  .number()
                  .nullable()
                  .test('isRequired', 'Required', (value) => {
                    const { isRequired } = x;
                    return !isRequired || (isRequired && value !== undefined && value !== null);
                  })
          )
        })
      };
      schemaArray.push(z);
    }

    if (x?.type === 'Readings' || x?.type === 'Readings_PL') {
      let z = {
        [`${removeSpecialCharactersForName}`]: yup.object().shape({
          [x?.formFieldId]: yup.object().shape({
            textBoxValue: yup
              .number()
              ?.nullable()
              .transform((value, originalValue) => {
                // if (!originalValue) return null;
                if (originalValue === '' || originalValue === null || originalValue === undefined)
                  return null;

                return parseFloat(originalValue);
              })

              // .test('isRequired', 'Required', (value) => (x.isRequired ? Boolean(value) : true)),
              .test('textBoxValueRequired', 'Required', function (value) {
                const { textBoxUnitValue } = this.parent;

                if (x.isRequired) {
                  // return Boolean(value);
                  return value !== null && value !== undefined && value !== '';
                }

                // if unit is entered but value is not, show error
                if (
                  !x.isRequired &&
                  textBoxUnitValue &&
                  (value === null || value === undefined || value === '')
                ) {
                  return false;
                }

                return true;
              }),

            textBoxUnitValue: yup
              .string()
              ?.nullable()
              // .test('isRequired', 'Required', (value) => (x.isRequired ? Boolean(value) : true))

              .test(
                'textBoxUnitRequired',
                'Unit is required if value is provided',
                function (value) {
                  const { textBoxValue } = this.parent;

                  if (x.isRequired) {
                    // return Boolean(value);
                    return value !== null && value !== undefined && value !== '';
                  }

                  // if value is entered but unit is not, show error
                  if (
                    !x.isRequired &&
                    textBoxValue !== null &&
                    textBoxValue !== undefined &&
                    textBoxValue !== '' &&
                    !value
                  ) {
                    return false;
                  }

                  return true;
                }
              )
          })
        })
      };
      schemaArray.push(z);
    }
  }

  const object = schemaArray?.reduce((result, item) => {
    const key = Object.keys(item)[0];
    const value = item[key];
    result[key] = value;
    return result;
  }, {});
  return object;
};

const equipmentSelectedMoreInfoFieldsSchema = {
  selectedMoreFields: yup
    .array()
    .of(
      yup.object().shape({
        Id: yup.string(),
        Value: yup.string(),
        IsSortable: yup.boolean(),
        checked: yup.boolean(),
        fieldName: yup.string(),

        formFieldId: yup.string(),
        options: yup
          .array(
            yup.object().shape({
              label: yup.string(),
              value: yup.string()
            })
          )
          .nullable(),
        order: yup.number(),
        isVisible: yup.boolean(),
        isReadOnly: yup.boolean(),
        required: yup.boolean(),
        type: yup.string(),
        name: yup.string(),
        label: yup.string()
      })
    )
    .nullable()
};

export {
  addOrEditEquipmentSchema,
  addOrEditEquipmentSchemaForNewEquipment,
  defaultValues,
  defaultValuesForNewEquipment,
  equipmentMoreFieldsSchema,
  equipmentSelectedMoreInfoFieldsSchema
};
